import { nonEmptyStringValidator, seatingDataValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { defaultSeatPickerConfig, seatPickerConfigValidator } from './config/config';
import { defaultSeatPickerDisplayText, seatPickerDisplayTextValidator } from './display-text';
import { seatPickerEventsValidator } from './events';
export const seatPickerPropsValidator = Validator.object({
    data: seatingDataValidator,
    selectedSeatIds: Validator.array({ items: nonEmptyStringValidator }),
    events: seatPickerEventsValidator,
    config: seatPickerConfigValidator,
    displayText: seatPickerDisplayTextValidator,
    isDisabled: Validator.optional(Validator.boolean())
});
export const defaultSeatPickerProps = {
    data: undefined,
    selectedSeatIds: [],
    events: {},
    config: defaultSeatPickerConfig,
    displayText: defaultSeatPickerDisplayText
};
